import React from 'react';
import PropTypes from 'prop-types';

import NotFound from 'pages/NotFound';
import withRouterSpecialisation from 'globals/withRouterSpecialisation';

function createComponentWithSpecialisationCheck(CustomComponent) {
  function UnderlyingComponent(props) {
    const { specialisation } = props;
    return !specialisation ? <NotFound /> : <CustomComponent {...props} />;
  }
  UnderlyingComponent.propTypes = {
    specialisation: PropTypes.string.isRequired,
  };
  return withRouterSpecialisation(UnderlyingComponent);
}
export default createComponentWithSpecialisationCheck;
